<script lang="ts">
  import { getContext, onMount, setContext } from "svelte";
  import { Route } from "../src/route";

  export let path: string;
  export let breadcrumb: any = undefined;

  let route = new Route({ path, parent: getContext("route") as any, breadcrumb });
  let store = route.store;

  // inject this route into context
  setContext("route", route);

  onMount(() => {
    return route.subscribe();
  });

  $: {
    route.breadcrumb = breadcrumb;
  }
</script>

{#if $store.matches}
  <slot {route} params={$store.params} />
{/if}
